import { useCallback, useRef } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

type SharingToolsContext = 'petition_dashboard_grow_petition_v1' | 'petition_dashboard_grow_petition_v2';

type UseSharingToolsTrackingResult = {
	trackView: (currentPosition: string) => void;
};

const EVENT_NAME = 'petition_manage_grow_your_petition_view';

export function useSharingToolsTracking(context: SharingToolsContext): UseSharingToolsTrackingResult {
	const track = useTracking();
	const isTrackedRef = useRef(false);

	const trackView = useCallback(
		(currentPosition: string) => {
			if (isTrackedRef.current || currentPosition === 'below') {
				return;
			}

			void track(EVENT_NAME, {
				context,
			});
			isTrackedRef.current = true;
		},
		[track, context],
	);

	return {
		trackView,
	};
}
